module.exports = "images/red.63e34fe5152375b044f0206e0887734f.png";